// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-list-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-bottom: 80px;
}

.item-list-grid-wrapper {
  flex: 1;
  min-height: 0;
  width: 100%;
  height: 100%;
}

.item-list-actions {
  margin-top: 10px;
}

.item-list-toolbar {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.item-list-toolbar-right {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.item-list-toolbar select {
  min-width: 0;

  background: #eef3f7;
  border-radius: 6px;
  border-color: #eef3f7;
  font: inherit;
  line-height: 1;
  padding: 12px;

  outline: none;
  font-size: 16px;

  padding-right: 18px;
  background-image: linear-gradient(45deg, transparent 50%, var(--muted) 50%),
    linear-gradient(135deg, var(--muted) 50%, transparent 50%);
  background-position: calc(100% - 12px) 52%, calc(100% - 7px) 52%;
  background-size: 5px 5px, 5px 5px;
  background-repeat: no-repeat;
  line-height: 22px;
  margin-left: 15px;
}

.item-list-tab {
  height: 40px;
  padding: 0 15px;

  border: 0;
  border-radius: 0px;

  background: #ffff;
  color: "#f0000";

  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

.item-list-tab:hover {
  background: #f7eef2;
}

.item-list-tab:active {
  background: #efe2e8;
  transform: translateY(1px);
}

.item-list-tab:focus-visible {
  outline: 2px solid rgba(227, 35, 35, 0.35);
  outline-offset: 2px;
}

.item-list-tab.is-active {
  background: #efe2e8;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.item-list-grid-wrapper .ag-root-wrapper {
  border: none !important;
}

.item-list-grid-wrapper .ag-header {
  background-color: #eef3f7;
  border-bottom: 1px solid #d8e0ea;
   border-radius: 0 !important;
}

.item-list-grid-wrapper .ag-header-cell {
  border-right: none;
  font-weight: 500;
}

.item-list-grid-wrapper .ag-header-row {
  border-bottom: none;
}

.item-list-grid-wrapper .ag-row,
.item-list-grid-wrapper .ag-cell {
  border-bottom: 1px solid #eef3f7;
}

.item-list-grid-wrapper .ag-cell {
  border-right: none;
}

.item-list-grid-wrapper .ag-header-viewport,
.item-list-grid-wrapper .ag-header-container {
  border-radius: 0 !important;
}

.item-list-grid-wrapper .ag-header-cell:first-child {
  border-top-left-radius: 0 !important;
}

.item-list-grid-wrapper .ag-header-cell:last-child {
  border-top-right-radius: 0 !important;
}

.user-selected-add-wrapper{
  margin-top: 10px;
  margin-bottom: 40px;
}

.stockGrid {
  display: flex;
  flex-direction: column;
}

.stockGrid__grid {
  height: 600px; /* sem dej svou výšku gridu */
}

.stockGrid__footer {
  padding: 6px 10px;
  border-top: 1px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
  padding-top: 15px;
}

.stockGrid__footerSep {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.stockGrid__chips {
  display: inline-flex;
  gap: 10px;
  flex-wrap: wrap;
}

.stockGrid__chip {
  display: inline-flex;
  gap: 6px;
}

.stockGrid__footerDivider {
  margin: 0 8px;
}

@media (max-width: 767px) {
  .card:has(> .card-body > .card-body-content > .main-stock-list) {
    height: 100dvh;
  }

  .card:has(> .card-body > .card-body-content > .main-stock-list) > .card-header {
    flex-shrink: 0;
  }

  .card:has(> .card-body > .card-body-content > .main-stock-list) > .card-body {
    overflow: hidden;
  }

  .card-body-content:has(> .main-stock-list) {
    min-height: 0;
  }

  .main-stock-list.item-list-card {
    flex: 1;
    min-height: 0;
    height: auto;
    margin-bottom: 0;
  }

  .main-stock-list > .item-list-toolbar,
  .main-stock-list > .stockGrid__footer,
  .main-stock-list > .item-list-actions {
    flex-shrink: 0;
  }

  .main-stock-list .item-list-toolbar-right {
    margin-top: 0;
  }

  .main-stock-list > .item-list-grid-wrapper {
    flex: 1;
    min-height: 0;
    height: auto;
  }

  .main-stock-list > .item-list-actions {
    margin-top: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/web/component/ItemList/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;;EAEZ,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,aAAa;;EAEb,aAAa;EACb,eAAe;;EAEf,mBAAmB;EACnB;8DAC4D;EAC5D,gEAAgE;EAChE,iCAAiC;EACjC,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;;EAEf,SAAS;EACT,kBAAkB;;EAElB,iBAAiB;EACjB,eAAe;;EAEf,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;GAC/B,2BAA2B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa,EAAE,6BAA6B;AAC9C;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,OAAO;IACP,aAAa;IACb,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;;IAGE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,OAAO;IACP,aAAa;IACb,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".item-list-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  margin-bottom: 80px;\r\n}\r\n\r\n.item-list-grid-wrapper {\r\n  flex: 1;\r\n  min-height: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.item-list-actions {\r\n  margin-top: 10px;\r\n}\r\n\r\n.item-list-toolbar {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.item-list-toolbar-right {\r\n  margin-left: auto;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.item-list-toolbar select {\r\n  min-width: 0;\r\n\r\n  background: #eef3f7;\r\n  border-radius: 6px;\r\n  border-color: #eef3f7;\r\n  font: inherit;\r\n  line-height: 1;\r\n  padding: 12px;\r\n\r\n  outline: none;\r\n  font-size: 16px;\r\n\r\n  padding-right: 18px;\r\n  background-image: linear-gradient(45deg, transparent 50%, var(--muted) 50%),\r\n    linear-gradient(135deg, var(--muted) 50%, transparent 50%);\r\n  background-position: calc(100% - 12px) 52%, calc(100% - 7px) 52%;\r\n  background-size: 5px 5px, 5px 5px;\r\n  background-repeat: no-repeat;\r\n  line-height: 22px;\r\n  margin-left: 15px;\r\n}\r\n\r\n.item-list-tab {\r\n  height: 40px;\r\n  padding: 0 15px;\r\n\r\n  border: 0;\r\n  border-radius: 0px;\r\n\r\n  background: #ffff;\r\n  color: \"#f0000\";\r\n\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n}\r\n\r\n.item-list-tab:hover {\r\n  background: #f7eef2;\r\n}\r\n\r\n.item-list-tab:active {\r\n  background: #efe2e8;\r\n  transform: translateY(1px);\r\n}\r\n\r\n.item-list-tab:focus-visible {\r\n  outline: 2px solid rgba(227, 35, 35, 0.35);\r\n  outline-offset: 2px;\r\n}\r\n\r\n.item-list-tab.is-active {\r\n  background: #efe2e8;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.item-list-grid-wrapper .ag-root-wrapper {\r\n  border: none !important;\r\n}\r\n\r\n.item-list-grid-wrapper .ag-header {\r\n  background-color: #eef3f7;\r\n  border-bottom: 1px solid #d8e0ea;\r\n   border-radius: 0 !important;\r\n}\r\n\r\n.item-list-grid-wrapper .ag-header-cell {\r\n  border-right: none;\r\n  font-weight: 500;\r\n}\r\n\r\n.item-list-grid-wrapper .ag-header-row {\r\n  border-bottom: none;\r\n}\r\n\r\n.item-list-grid-wrapper .ag-row,\r\n.item-list-grid-wrapper .ag-cell {\r\n  border-bottom: 1px solid #eef3f7;\r\n}\r\n\r\n.item-list-grid-wrapper .ag-cell {\r\n  border-right: none;\r\n}\r\n\r\n.item-list-grid-wrapper .ag-header-viewport,\r\n.item-list-grid-wrapper .ag-header-container {\r\n  border-radius: 0 !important;\r\n}\r\n\r\n.item-list-grid-wrapper .ag-header-cell:first-child {\r\n  border-top-left-radius: 0 !important;\r\n}\r\n\r\n.item-list-grid-wrapper .ag-header-cell:last-child {\r\n  border-top-right-radius: 0 !important;\r\n}\r\n\r\n.user-selected-add-wrapper{\r\n  margin-top: 10px;\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.stockGrid {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.stockGrid__grid {\r\n  height: 600px; /* sem dej svou výšku gridu */\r\n}\r\n\r\n.stockGrid__footer {\r\n  padding: 6px 10px;\r\n  border-top: 1px solid #ddd;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n  padding-top: 15px;\r\n}\r\n\r\n.stockGrid__footerSep {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.stockGrid__chips {\r\n  display: inline-flex;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.stockGrid__chip {\r\n  display: inline-flex;\r\n  gap: 6px;\r\n}\r\n\r\n.stockGrid__footerDivider {\r\n  margin: 0 8px;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .card:has(> .card-body > .card-body-content > .main-stock-list) {\r\n    height: 100dvh;\r\n  }\r\n\r\n  .card:has(> .card-body > .card-body-content > .main-stock-list) > .card-header {\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .card:has(> .card-body > .card-body-content > .main-stock-list) > .card-body {\r\n    overflow: hidden;\r\n  }\r\n\r\n  .card-body-content:has(> .main-stock-list) {\r\n    min-height: 0;\r\n  }\r\n\r\n  .main-stock-list.item-list-card {\r\n    flex: 1;\r\n    min-height: 0;\r\n    height: auto;\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  .main-stock-list > .item-list-toolbar,\r\n  .main-stock-list > .stockGrid__footer,\r\n  .main-stock-list > .item-list-actions {\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .main-stock-list .item-list-toolbar-right {\r\n    margin-top: 0;\r\n  }\r\n\r\n  .main-stock-list > .item-list-grid-wrapper {\r\n    flex: 1;\r\n    min-height: 0;\r\n    height: auto;\r\n  }\r\n\r\n  .main-stock-list > .item-list-actions {\r\n    margin-top: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
